'use client';

import classNames from '@sindresorhus/class-names';
import Image from 'next/image';
import Link from 'next/link';

import {AppType, ChipData} from '@web-catalog/types';

import {useChipsAnalytics} from '@web-catalog/utils/analytics';

import styles from './Chip.module.scss';
import {a11yLabelsForChipTypes, getItemPropForChipType} from './utils';

type Props = {
  appType: AppType;
  data: ChipData;
  className?: string;
  isLinkComponent?: boolean;
};

export const Chip = ({
  appType,
  data: {text, iconUrl, href, colorVariant, capitalizeText, type, testId},
  className,
  isLinkComponent = true,
}: Props) => {
  const {logChipsClick} = useChipsAnalytics();

  const content = (
    <>
      {iconUrl && (
        <Image
          className={styles.icon}
          src={iconUrl}
          width={16}
          height={16}
          aria-hidden="true"
          alt=""
        />
      )}
      {!!a11yLabelsForChipTypes[type] && (
        <span className="visually-hidden">
          {a11yLabelsForChipTypes[type]}:&nbsp;
        </span>
      )}
      <span className={classNames(capitalizeText && styles.capitalizedText)}>
        {text}
      </span>
    </>
  );

  if (isLinkComponent) {
    return (
      <Link
        className={classNames(styles.root, styles[colorVariant], className)}
        href={href}
        itemProp={getItemPropForChipType(type)}
        onClick={() => logChipsClick(appType, type, text)}
        prefetch={false}
        data-testid={testId}
      >
        {content}
      </Link>
    );
  }

  return (
    <div
      className={classNames(styles.root, styles[colorVariant], className)}
      itemProp={getItemPropForChipType(type)}
      data-testid={testId}
    >
      {content}
    </div>
  );
};
